<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Transfert d'agence et finance digitale" />
            <TransfertArgent />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import TransfertArgent from '../Services/TransfertArgent'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'TransfertArgentPage',
    components: {
        NavBar,
        PageTitle,
        TransfertArgent,
        FooterComp,
    }
}
</script>